import styled from 'styled-components';

import { MEDIA_QUERIES } from "@constants";

export const DEIPageDonutChartsDIV = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;

  select {
    display: block;
    margin: 0 auto 30px;
    max-width: 180px;
  }

  ${MEDIA_QUERIES.M} {
    padding-top: 72px; /* Height of Select + margin */
    
    select {
      position: absolute;
      top: 0;
      right: 0;
      margin: 0;
    }
  }
`;

export const DEIPageDonutChartsChartWrapperDIV = styled.div`
  flex: 0 0 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;

  ${MEDIA_QUERIES.M} {
    flex: 0 0 50%;
    padding: 0 15px;
    margin-bottom: 0;
  }

  h5 {
    text-align: center;
    margin-bottom: 30px;
  }

  svg {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0 auto 30px;
  }
`;
